import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import appConfig from '../../../../../appConfig/index.js';
import http from '../../../../../Common/Services/HttpService/index.js';
import { UPDATE_CART_ITEM_NEW } from '../../../../../Store/Slices/EmployeeProfile/index.js';
import { UPDATE_ENROLLMENT_DATA } from '../../../../../Store/Slices/Enrollment/index.js';
import {
  onLoadAPI,
  onLoadProductAPI,
} from '../../../../../Store/Slices/Entities/response/index.js';
import {
  ADD_PET_LIST,
  ADD_PET_TOKEN,
  DELETE_FULL_PET_LIST,
  OFFERED_COVERAGE_BUIDS,
  REMOVE_CURRENTSTEP_ALERT_MESSAGE,
  SET_ALERT_MESSAGE,
  UPDATE_LOADING,
  UPDATE_WAIVE_PRODUCT_WITHOUT_PERSONBUID,
} from '../../../../../Store/Slices/InsuredInfo/index.js';
import { CHECK_ELIGIBILITY } from '../../../../../Store/Slices/InsuredInfo/index.js';
import Checkbox from '../../../../Atoms/Checkbox/index.js';
import Loader from '../../../../Atoms/Loader/index.js';
import resumeContent from '../../Content/ResumeContent.json';
import ServiceHelper from '../../../../Utils/Helper/MappingHelper.js';
import { Button } from '../../Atoms/index';
import PetComponent from '../Flow8/PetAssureNationModal.js';
import PetTable from '../Flow8/PetAssureNationTable.js';
import Content from '../../Content/PetAssureNationContent.json';
import { continueBtnLabelHelper, screenNames } from '../../Helper/continueBtnLabelHelper.js';
import { getErrorMessages, removeUnwantedProps } from '../../Helper/MappingHelper.js';
import { createPetListPayloadNew, toPlainPhoneNumber,convertToStandardFrequency } from '../../Helper/PetHelper.js';
import { useNavigationHook } from '../../Hooks/NavigationHook.js';
import ProductDescription from './ProductDescription/index.js';
import './styles.css';

const PetTool = (props) => {
  const serviceHelper = new ServiceHelper();
  const { currentStep, previousStep, formsConfig, stepKeys } = useNavigationHook();
  const [currentBuids, setCurrentBuids] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [petPolicies, setPetPolicies] = useState([]);
  const { employeeIndex } = props;
  const buid = props.employee[employeeIndex]?.personBuid;
  let personBuid = buid;
  const dispatch = useDispatch();
  const { onBack, nextStep, flowType, onNext } = props;
  const [continueBtnLabel, setContinueBtnLabel] = useState('Continue');
  const { insuredInfo, process } = useSelector((storeState) => storeState);
  const enrollmentProcessBuid = process?.enrollmentProcess?.[0]?.[0]?._Result?.bUID;
  const currentReduxState = useSelector((storeState) => storeState);
  const subscribedProductBuid =
    currentReduxState?.enrollment?.enrollmentData?.contract?.subscribedElements;
  const getAllPossibleChoicesConfiguration =
    currentReduxState?.entities?.response?.onLoadResponseList?.[`${currentStep}`]
      ?.getAllPossibleChoicesConfigurationForProduct?._Result?.[0];
  const { radioSelectedValuePetNation } = useSelector((storeState) => storeState.employeeProfile);
  let productFamily = formsConfig?.forms?.[currentStep]?.productFamily;
  const productIdentifierBuid = currentReduxState.process?.productFamilyIdentifier[productFamily];
  let insuredQuestionAnswers = insuredInfo[currentStep]?.InsuredQuestionAnswers?.[buid];
  const coverages = useSelector(
    (storeState) =>
      storeState?.entities?.response?.onLoadResponseList[currentStep]?.AddSubscriptionForChoice
        ?.contract?.subscribedElements[0]?.coverages
  );
  const enrollmentData = useSelector((state) => state.enrollment?.enrollmentData);
  let subscribedProducts = enrollmentData?.contract?.subscribedElements || [];

  let subscribedCoverageBuid = [];
  for (let i = 0; i < coverages?.length; i++) {
    subscribedCoverageBuid.push(coverages[i]?.bUID);
  }
  const searchPolicyProcessResource = useSelector(
    (storeState) =>
      storeState.entities.response?.onLoadResponseList?.[
        `SearchPolicyProcessResources${currentStep}`
      ]?._Result
  );
  const personalInfo = useSelector(
    (storeState) =>
      storeState?.entities?.response?.onLoadResponseList?.PersonalInformation?.personalInformation
  );
  const employmentInfo = useSelector(
    (storeState) =>
      storeState?.entities?.response?.onLoadResponseList?.EmploymentInformation
        ?.employmentInformation
  );
  const addressInfo = useSelector((storeState) => storeState?.employeeProfile?.employeeProfile);
  const employeeId = employmentInfo?.employeeIdentity;
  const oneCodeValue = employmentInfo?.oneCode;
  const {
    firstName,
    lastName,
    middleName,
    workEmail,
    personalEmail,
    personalPhone: phoneNumber,
    state,
    city,
    zipCode,
    line1: addressLine1,
    line2: addressLine2,
  } = personalInfo || {};
  const { payFrequency } = employmentInfo || {};
  let petlist = currentReduxState?.insuredInfo?.[`${currentStep}`]?.petList || [];
  let subscribedElementsDataFromValidateContract = subscribedProductBuid?.filter(
    (e) => e.subscribedProduct.productCode.buid === productIdentifierBuid
  );
  const waiveCoverage = insuredInfo[currentStep]?.WaiveCoverage;
  const isWaiveCoverage = waiveCoverage?.[0]?.waiveProduct ?? false;
  let continueBtnObj = {
    flowType: props.flowType,
    totalProductCount: subscribedProducts.length,

    screenType: screenNames.INSURED_QUESTIONNAIRE_SCREEN,
    hasDisclosureStatement: false,
    isWaivedOffFlag: false,
  };

  const loadExternalScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    const isLoaded = !!document.querySelector(`script[src*="${appConfig?.NATIONWIDE_SCRIPT_URL}"]`);
    if (isLoaded) {
      return;
    } else {
      loadExternalScript(appConfig?.NATIONWIDE_SCRIPT_URL)
        .then(() => console.log('Script loaded successfully'))
        .catch((err) => console.error('Failed to load script', err));
    }
  }, []);

  useEffect(() => {
    const link = document.createElement('link');
    link.href = appConfig?.NATIONWIDE_CSS_URL;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link); // Cleanup on unmount if needed
    };
  }, []);

  useEffect(() => {
    setContinueBtnLabel(
      continueBtnLabelHelper({
        ...continueBtnObj,
        productIdentifierBuid,
      })
    );
  }, [productIdentifierBuid]);

  useEffect(() => {
    setContinueBtnLabel(
      continueBtnLabelHelper({
        ...continueBtnObj,
        productIdentifierBuid,
        isWaivedOffFlag: isWaiveCoverage,
      })
    );
  }, [isWaiveCoverage]);

  let showButton = false;
  if (radioSelectedValuePetNation == 'waive') {
    showButton = true;
  }
  let btnContinueDisabled = false;
  if ((petlist?.length === 0 || petlist === undefined) && !isWaiveCoverage) {
    btnContinueDisabled = true;
  }
  const currentStepIndex = stepKeys.findIndex((step) => step === currentStep);
  const nextStepGoingTobe = stepKeys[currentStepIndex + 1];
  const buttonText =
    nextStepGoingTobe === 'EnrollmentSummary' ? 'Continue to Summary' : 'Continue to Next Product';
  const currentOfferedCoverageBuids =
    currentReduxState?.entities?.response?.onLoadResponseList?.[currentStep]
      ?.getAllPossibleChoicesConfigurationForProduct?._Result || [];
  const validateContractInsure =
    currentReduxState?.entities.response?.onLoadResponseList?.ValidateContractData?._Result
      ?.contract?.insureds || [];
  const nonSharedAdditionalDataSet = insuredInfo[currentStep]?.nonSharedAdditionalDatas;
  const subscribedElementsFromValidateContract =
    currentReduxState?.entities?.response?.onLoadResponseList?.ValidateContractData?._Result
      ?.contract?.subscribedElements;
  // let subscribedElementsDataFromValidateContract = subscribedElementsFromValidateContract?.filter(e => e.subscribedProduct.productCode.buid === productIdentifierBuid);
  let subscribedProductIdentifierBuid =
    subscribedElementsDataFromValidateContract?.[0]?.subscribedProduct?.buid;
  const ProcessAPIPet =
    currentReduxState?.entities?.response?.onLoadResponseList?.ProcessAPIPet?.contract;
  const nextStepCallOne = async () => {
    // nextStep();
    if (personBuid && isWaiveCoverage === false && insuredQuestionAnswers) {
      let insuredQuestionAnswers = insuredInfo[currentStep]?.InsuredQuestionAnswers;
      setShowLoader(true);
      let resp = await serviceHelper.sendApiRequest('/createOrUpdateInsuredQuestionAnswer', {
        productIdentifierBuid,
        insuredQuestionAnswers,
        currentStep,
        currentOfferedCoverageBuids,
        enrollmentProcessBuid,
        validateContractInsure,
        nonSharedAdditionalDataSet,
      });
      if (resp.data && resp.status === 200) {
        dispatch(
          onLoadAPI({
            CreateOrUpdateInsuredCIGeneral: resp.data,
            isAPICallInProgress: false,
          })
        );
        // await checkCoveragePersonEligibility();
        setShowLoader(false);
        return true;
      } else {
        setShowLoader(false);
        return false;
      }
      // Need to refactor this code props.flowType != 1
    } else if (personBuid && isWaiveCoverage === true && props.flowType !== 1) {
      setShowLoader(true);
      // await prepareSubscriptionForChoice();
      return true;
    } else {
      //return await validateSubscribedProductdata();
      return true;
    }
  };

  const [apiCallState, setApiCallState] = useState('');

  useEffect(() => {
    if (currentBuids?.length > 0 && currentOfferedCoverageBuids.length > 0) {
      setApiCallState('onLoad');
    }
  }, [currentBuids, currentOfferedCoverageBuids]);

  useEffect(() => {
    if (currentOfferedCoverageBuids.length > 0) {
      setApiCallState('onLoad');
    }
  }, [currentOfferedCoverageBuids]);

  let requestData = {
    employeeId: employeeId,
    employerId: oneCodeValue,
    employeeFirstName: firstName,
    employeeMiddleName: middleName,
    employeeLastName: lastName,
    employeeEmailAddress: workEmail || personalEmail,
    employeeMobilePhone: toPlainPhoneNumber(phoneNumber),
    employeeAddress1: addressLine1,
    employeeAddress2: addressLine2,
    employeeAddressCity: city,
    employeeAddressState: state,
    employeeAddressZip: zipCode,
    employeePayPeriod: convertToStandardFrequency(payFrequency)?.code,
  };

  useEffect(() => {
    if (currentStep && enrollmentProcessBuid) {
      getInitialData();
      fetchPetEnrollmentPoliciesSummary();
    }
  }, [currentStep, enrollmentProcessBuid, subscribedProductBuid?.length > 0]);
  const fetchPetEnrollmentPoliciesSummary = async () => {
    try {
      dispatch(UPDATE_LOADING(true));
      setShowLoader(true);

      const response = await http.post(
        appConfig.SSP_MID_URL + '/v1/get-pet-enrollment-policies-summary',
        { requestData }
      );
      let policies = response?.data?.petSummaryData?.policies?.filter(
        (policy) =>
          policy.applicationStatus === 'Pending' || policy.applicationStatus === 'Enrolled'
      );
      let petToken = response?.data?.token;
      setPetPolicies(policies);
      if (response) {
        const petListPayload = createPetListPayloadNew(policies);

        dispatch(ADD_PET_LIST({ product: currentStep, petList: petListPayload }));
        dispatch(ADD_PET_TOKEN({ product: currentStep, petToken: petToken }));
      } else {
        console.error('SAML API call failed.');
      }
    } catch (error) {
      setShowLoader(false);
      console.error('Error occurred during SAML API call:', error);
    } finally {
      setShowLoader(false);
      dispatch(UPDATE_LOADING(false));
    }
  };

  const hasErrors = getErrorMessages(currentStep);

  const getInitialData = async () => {
    dispatch(UPDATE_LOADING(true));
    const reduxState = removeUnwantedProps(currentReduxState, resumeContent.resumeUnwantedProps);
    const stepContext = { portalStep: currentStep, reduxState };

    const qleEndorsementProcessBuid =
      currentReduxState?.entities?.response?.onLoadResponseList?.initNewIndividualEndorsementProcess
        ?._Result?.processEntity?.buid;
    const enrollmentValue =
      currentReduxState?.enrollment?.enrollmentData?.contract?.subscribedElements || [];
    let declinedProduct = enrollmentValue?.filter(
      (e) => e?.subscribedProduct?.productCode?.buid === productIdentifierBuid
    );
    let isDeclinedProduct =
      declinedProduct?.[0]?.subscribedProduct?.status === 'cDeclined' ? true : false;
    const enrollmentType = currentReduxState?.employeeProfile?.enrollmentType;
    const reasonType = currentReduxState?.employeeProfile?.reasonType;
    const isAdmin = currentReduxState?.callCenter?.isAdmin;
    const ongoingEnrollmentType = enrollmentType === 'editNewEnrollmentDuringOE';
    const ongoingReasonType = reasonType === 'OE';
    dispatch(REMOVE_CURRENTSTEP_ALERT_MESSAGE(currentStep));
    try {
      const response = await http.post(appConfig.SSP_MID_URL + '/v1/pet-insurance-load', {
        stepContext,
        enrollmentProcessBuid,
        subscribedProductBuid,
        productIdentifierBuid,
        isRework:
          isDeclinedProduct ||
          qleEndorsementProcessBuid ||
          isAdmin ||
          ongoingReasonType ||
          ongoingEnrollmentType
            ? true
            : false,
      });

      Object.keys(response.data.data).forEach((key) => {
        const result = { _Result: response.data.data?.[key]?.data };
        switch (key) {
          case 'searchPolicyProcessResources':
            if (response.data.data[key]?.success) {
              dispatch(onLoadAPI({ [`SearchPolicyProcessResources${currentStep}`]: result }));
            } else {
              dispatch(
                SET_ALERT_MESSAGE({
                  type: 'error',
                  errorCode: response?.data?.data[key]?.data?.error?.code || '520',
                  continue: true,
                  id: 'searchPolicyProcessResources',
                  show: true,
                  page: currentStep,
                })
              );
            }
            break;
          default:
            break;
        }
      });

      dispatch(UPDATE_LOADING(false));
    } catch (e) {
      dispatch(UPDATE_LOADING(false));
      dispatch(
        SET_ALERT_MESSAGE({
          type: 'error',
          errorCode: '520',
          continue: true,
          id: 'petInsuranceLoad',
          show: true,
          page: currentStep,
        })
      );
    }
  };

  const callOnNext = async () => {
    // Your logic for proceeding to the next product goes here...
    await nextStepCallOne();

    onNext();
  };

  const reduxState = removeUnwantedProps(currentReduxState, resumeContent.resumeUnwantedProps);

  const stepContext = { portalStep: currentStep, reduxState };

  const coverageBuid = getAllPossibleChoicesConfiguration?.coverage?.bUID;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      // Show loader
    } else {
      // Hide loader
    }
  }, [loading]);

  return (
    <div>
      {showLoader ? (
        <Loader loading={showLoader} className="loaderUpdateCls" />
      ) : (
        <>
          <ProductDescription
            resources={searchPolicyProcessResource}
            buid={buid}
            {...{ ...props.parentProps, ...Content.idealContent }}
          />
          <PetTable {...props}></PetTable>
          <PetComponent isCheckboxChecked={isWaiveCoverage} {...props} />
        </>
      )}

      <div id="pet-nav" className="button-group">
        <Button
          type="button"
          onClick={onBack}
          className="me-3 btn btn-outline-primary primaryOutline"
        >
          Back
        </Button>

        {
          <Button
            type="button"
            onClick={isWaiveCoverage ? callOnNext : callOnNext}
            className="btn btn-primary continue-btn primaryBackground custom-next-button"
            name="continue-to-next-product"
            // style={{ backgroundColor: '#002C77' }} // Add this line
          >
            {continueBtnLabel}
          </Button>
        }
      </div>
    </div>
  );
};

export default PetTool;
